module.exports = __webpack_public_path__ + "static/media/mug-tea.693b0dea.svg";